import { TFunction } from 'i18next';
import { UsersViewMode } from 'routes/Users/enums';
import { UsersCounters } from 'utils/fetch/hooks/useUsersQueryHook';
import { CountMarkTypes } from '@lib/components/CountMark/CountMark';
import {
  TabBarItem as TabBarItemType,
  TabBarItemTypes,
} from '@lib/components/TabBar/constants';

type Args = {
  counters: UsersCounters;
  t: TFunction<'translation', undefined>;
};

export default function getUsersTabs({ counters, t }: Args): TabBarItemType[] {
  return [
    {
      label: t('all'),
      value: UsersViewMode.All,
      counter: counters?.all,
    },
    {
      label: t('full-admins'),
      value: UsersViewMode.FullAdmins,
      counter: counters?.fullAdmins,
    },
    {
      label: t('users'),
      value: UsersViewMode.Users,
      counter: counters?.users,
    },
    {
      label: t('unassigned'),
      value: UsersViewMode.Unassigned,
      counter: counters?.unassigned,
      counterType: CountMarkTypes.orange,
      type: TabBarItemTypes.orange,
    },
  ];
}
